'use client';

import { useEffect } from 'react';
import { ErrorDisplay } from '@/components/error-display';

export default function ContractorError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Contractor route error:', error);
  }, [error]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <ErrorDisplay
        title="Something went wrong"
        message="We ran into a problem loading this page. Please try again."
        error={error}
        onRetry={reset}
        onGoHome={() => window.location.href = '/dashboard'}
      />
    </div>
  );
}
